import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { NotificationTypes } from 'src/app/app.enums';
import { GeneratedProductDescriptionsSuggestions } from 'src/app/common/chatgpt-dialog/chatgpt-dialog.component';
import { ImageCroppedResponse } from 'src/app/common/image-cropper/image-cropper.component';
import { AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { CloudinaryImageService } from 'src/app/Services/cloudinary-image.service';
import { GalleryCoverPhoto, GalleryPersonlaProduct, GalleryProductService, getGalleryProductImages } from 'src/app/Services/Gallery-Products-Service/galleryproduct.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { SubscriptionRulesService } from 'src/app/Services/subscription-rules.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-gallery-product',
    templateUrl: './gallery-product.component.html',
    styleUrls: ['./gallery-product.component.css'],
    standalone: false
})
export class GalleryProductComponent implements OnInit {
    @ViewChild('additionalFileUploadCmp') additionalFileUploadCmp!: FileUpload;
    public enableCropper: boolean = true;
    public currentSelectedImageToCrop?: File;
    public showCropperDialog: boolean = false;
    public additionalFiles: any[] = [];
    public selectedFile!: File;
    public authConfig!: AuthConfig;
    public isAdditionalImage: boolean = false;
    public galleryData: GalleryPersonlaProduct = {} as GalleryPersonlaProduct;
    public selectedProductId!: string;
    public productImages: getGalleryProductImages[] = [];
    public galleryProductId!: string;
    public isEditMode: boolean = false;
    public isProductAvailable: boolean = true;
    public isProductCreating: boolean = false;
    public showchatGPTDialog: boolean = false
    public showMoreProductsSidebarVisible: boolean = false;
    public isFreePlanUser: boolean = true;
    public isAuthenticated: boolean = false;
    public items: MenuItem[] | undefined;
    public home: MenuItem | undefined;
    constructor(
        private confirmationService: ConfirmationService,
        private authService: AuthService,
        private ngxSpinnerService: NgxSpinnerService,
        private GalleryProductService: GalleryProductService,
        private notificationsService: NotificationsService,
        private uploadService: CloudinaryImageService,
        private route: ActivatedRoute,
        private router: Router,
        private subscriptionRulesService:SubscriptionRulesService,
        private transloco: TranslocoService
    ) { }

    ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
        this.route.params.subscribe((params) => {
            if (params['Id']) {
                this.selectedProductId = params['Id'];
                console.log('selectedProductId', this.selectedProductId)
                if (this.selectedProductId) {
                    this.getGalleryProductById(this.selectedProductId);
                    this.getGalleryProductImages(this.selectedProductId);
                }
            }
        });
        this.isAuthenticated = this.authService.isAuthenticated();
        if(this.isAuthenticated){
            this.isFreePlanUser = this.authService.isFreePlanUser();
        }
    }
    public createArtWork($event: any) {
        this.isProductCreating = true;
        this.additionalFiles = [];
        this.additionalFileUploadCmp?.clear();
        // Reset galleryData to its initial state
        this.galleryData = {} as GalleryPersonlaProduct; 
        this.productImages = [];
        this.selectedProductId = '';
    }
    
    public saveGalleryProduct(event: any) {
        this.confirmationService.confirm({
            message: this.transloco.translate('galleryProduct.confirmSaveProduct', { name: this.galleryData.Name }),
            accept: () => {
                this.ngxSpinnerService.show();
                this.GalleryProductService.createGalleryProduct(this.galleryData).subscribe((response) => {
                    this.ngxSpinnerService.hide();
                    if (response.Success) {
                        console.log(response.ResponseData);
                        var productId = response.ResponseData as string;
                        if (productId) {
                            this.router.navigate(['/gallery-products', productId]);
                            this.isAdditionalImage = true
                            this.GalleryProductService.connectUploadedImages(productId, this.galleryData.ProductImgUrl!).subscribe((response: ResponseObject) => {
                            });
                            this.getGalleryProductImages(productId)
                        }
                        this.notificationsService.showNotification(this.transloco.translate('galleryProduct.success'), this.transloco.translate('galleryProduct.productDataSavedSuccessfully'), NotificationTypes.Success);
                    } else {
                        console.error(response);
                        this.notificationsService.showNotification(this.transloco.translate('galleryProduct.error'), response.ResponseMessage, NotificationTypes.Error);
                    }
                }, (error) => {
                    console.error(error);
                    this.ngxSpinnerService.hide();
                });
            }
        });
    }

    private getGalleryProductById(selectedProductId: string) {
        this.ngxSpinnerService.show();
        this.GalleryProductService.getGalleryProductById(selectedProductId).subscribe(
            (galleryProduct: GalleryPersonlaProduct) => {
                this.galleryData = galleryProduct;
                this.items = [{ label: 'View Gallery Products', routerLink: ['/galleries', 'view-gallery-products'] },
                 { label: this.galleryData.Name  }];
                this.home = { icon: 'pi pi-home', routerLink: '/' };
                console.log('getGalleryProductById:', this.galleryData);
                this.ngxSpinnerService.hide();
            },
            (error) => {
                console.error('Error fetching gallery product:', error);
                this.ngxSpinnerService.hide();
                this.notificationsService.showNotification(this.transloco.translate('galleryProduct.error'), this.transloco.translate('galleryProduct.failedToFetchGalleryProductData'), NotificationTypes.Error);
            }
        );
    }

    public deleteGalleryProduct(selectedProduct: GalleryPersonlaProduct) {
        this.confirmationService.confirm({
            message: this.transloco.translate('galleryProduct.confirmDeleteProduct', { name: selectedProduct.Name }),
            accept: () => {
                this.ngxSpinnerService.show();
                this.GalleryProductService.deleteGalleryProductById(selectedProduct.Id).subscribe(
                    (response: ResponseObject) => {
                        this.ngxSpinnerService.hide();
                        if (response.Success) {
                            this.router.navigate(['/galleries', 'view-gallery-products'])
                            this.notificationsService.showNotification(this.transloco.translate('galleryProduct.success'), this.transloco.translate('galleryProduct.productDeletedSuccessfully'), NotificationTypes.Success);
                        } else {
                            this.notificationsService.showNotification(this.transloco.translate('galleryProduct.error'), response.ResponseMessage, NotificationTypes.Error);
                        }
                    },
                    (error) => {
                        console.error('Error deleting gallery product:', error);
                        this.ngxSpinnerService.hide();
                        this.notificationsService.showNotification(this.transloco.translate('galleryProduct.error'), this.transloco.translate('galleryProduct.failedToDeleteGalleryProduct'), NotificationTypes.Error);
                    }
                );
            }
        });
    }

    public onFileSelected(files: File[], isAdditionalImage: boolean) {
        if (files.length > 0) {
            this.currentSelectedImageToCrop = files[0];
            const isImage: boolean = this.currentSelectedImageToCrop.type.includes('image');

            if (isImage && this.enableCropper) {
                this.isAdditionalImage = isAdditionalImage;
                this.showCropperDialog = true;
            }
        }
    }

    public onImageCropped($cropResponse: ImageCroppedResponse) {
        console.log($cropResponse);
        this.showCropperDialog = false;
        this.selectedFile = $cropResponse.CroppedImage;
        if (this.selectedFile) {
            //upload the cropped cover image
            const formData = new FormData();
            formData.append('ImageFile', this.selectedFile);
            this.ngxSpinnerService.show();
            this.uploadService.uploadImage(formData).subscribe((imageUrl: string) => {
                if (this.selectedProductId) {
                    if ($cropResponse.IsAdditionalImage) {
                        //incase the user has uploaded the additional image (not the cover photo), connect it as an additional image
                        this.ngxSpinnerService.show();
                        //after they have been uploaded, connect them with the product so we don't have to save them on "Save" click
                        this.GalleryProductService.connectUploadedImages(this.selectedProductId, imageUrl).subscribe((response: ResponseObject) => {
                            if (response.Success) {
                                console.log(response.ResponseData)
                                //refresh the product images
                                this.getGalleryProductImages(this.selectedProductId);

                                this.notificationsService.showNotification(this.transloco.translate('galleryProduct.success'), this.transloco.translate('galleryProduct.imageUploadedSuccessfully'), NotificationTypes.Success);
                            } else {
                                this.notificationsService.showNotification(this.transloco.translate('galleryProduct.error'), this.transloco.translate('galleryProduct.errorWhileSavingData'), NotificationTypes.Error);
                            }
                            this.ngxSpinnerService.hide();
                        }, error => {
                            console.error(error);
                            this.ngxSpinnerService.hide();
                        });
                    }

                } else {
                    //since we are creating a new product, so we can't connect the uploaded image to a product right now
                    this.galleryData.ProductImgUrl = imageUrl;
                    this.ngxSpinnerService.hide();
                }
            }, error => {
                console.error(error);
                this.ngxSpinnerService.hide();
            });
        }
    }
    public onAdditionalFileCleard($event: any) {
        this.additionalFiles = [];
    }
    public onImageCropperClose($event: any) {
        this.showCropperDialog = false;
        if ($event.skipCropping) {
            // Handle skipping cropping if needed
        }
    }

    public uploadAdditionalFiles() {
        if (this.additionalFiles.length === 0) {
            return;
        }
        const formData = new FormData();
        for (const file of this.additionalFiles) {
            formData.append('ImageFile', file);
        }
        this.ngxSpinnerService.show();
        this.uploadService.uploadImages(formData).subscribe((response: string[]) => {
            this.ngxSpinnerService.hide();
            if (response.length > 0) {
                if (this.selectedProductId) {
                    this.ngxSpinnerService.show();
                    this.GalleryProductService.connectUploadedImages(this.selectedProductId, response.join(',')).subscribe((response: ResponseObject) => {
                        if (response.Success) {
                            this.getGalleryProductImages(this.selectedProductId);
                            this.notificationsService.showNotification(this.transloco.translate('galleryProduct.success'), this.transloco.translate('galleryProduct.additionalImagesUploadedSuccessfully'), NotificationTypes.Success);
                        } else {
                            this.notificationsService.showNotification(this.transloco.translate('galleryProduct.error'), this.transloco.translate('galleryProduct.errorWhileSavingData'), NotificationTypes.Error);
                        }
                        this.ngxSpinnerService.hide();
                    }, error => {
                        console.error(error);
                        this.ngxSpinnerService.hide();
                    });
                }
            }
        }, error => {
            console.error(error);
            this.ngxSpinnerService.hide();
        });
    }

    public deleteAdditionalImage(selectedImageData: getGalleryProductImages) {
        this.confirmationService.confirm({
            message: this.transloco.translate('galleryProduct.confirmDeleteAdditionalImage'),
            accept: () => {
                this.ngxSpinnerService.show();
                this.GalleryProductService.deleteAdditionalImage(selectedImageData.Id).subscribe(
                    (response: ResponseObject) => {
                        this.ngxSpinnerService.hide();
                        if (response.Success) {
                            this.notificationsService.showNotification(this.transloco.translate('galleryProduct.success'), this.transloco.translate('galleryProduct.additionalImageDeletedSuccessfully'), NotificationTypes.Success);
                            this.getGalleryProductImages(this.selectedProductId); // Refresh the images list
                        } else {
                            this.notificationsService.showNotification(this.transloco.translate('galleryProduct.error'), response.ResponseMessage, NotificationTypes.Error);
                        }
                    },
                    (error) => {
                        console.error('Error deleting additional image:', error);
                        this.ngxSpinnerService.hide();
                        this.notificationsService.showNotification(this.transloco.translate('galleryProduct.error'), this.transloco.translate('galleryProduct.failedToDeleteAdditionalImage'), NotificationTypes.Error);
                    }
                );
            }
        });
    }

    private getGalleryProductImages(productId: string) {
        this.ngxSpinnerService.show();
        this.GalleryProductService.getGalleryProductImages(productId).subscribe((images: getGalleryProductImages[]) => {
            this.ngxSpinnerService.hide();
            this.productImages = images;
        }, error => {
            console.error(error);
            this.ngxSpinnerService.hide();
        });
    }

    public updateArtistProductCoverPhoto(selectedProduct: getGalleryProductImages) {
        if (selectedProduct.IsGalleryImg) {
            return;
        }
        var data: GalleryCoverPhoto = {
            ProductId: selectedProduct.GalleryProductId,
            CoverImageUrl: selectedProduct.ImageUrl
        };
        this.ngxSpinnerService.show();
        this.GalleryProductService.updateGalleryProductCoverPhoto(data).subscribe((response) => {
            this.ngxSpinnerService.hide();
            if (response.Success) {
                this.galleryData.ProductImgUrl = selectedProduct.ImageUrl;
                this.notificationsService.showNotification(this.transloco.translate('galleryProduct.success'), this.transloco.translate('galleryProduct.imageHasBeenSetSuccessfully'), NotificationTypes.Success);

            } else { this.notificationsService.showNotification(this.transloco.translate('galleryProduct.error'), response.ResponseMessage, NotificationTypes.Error); }
        }, (error) => { });
    }

    public onAdditionalFileCleared($event: any) {
        this.additionalFiles = [];
    }

    public onAdditionalFileSelected($event: any) {
        this.additionalFiles = $event.currentFiles;
    }

    public removeChosenFile($event: File) {
        const index = this.additionalFiles.indexOf($event);
        if (index >= 0) {
            this.additionalFiles.splice(index, 1);
        }
    }

    public removeImg($event: any) {
        this.galleryData.ProductImgUrl = '';
    }

    

    public handleImageHover(productImages: any, isHovered: boolean) {
        productImages.hovered = isHovered;
    }

    public showChatGPTDialog($event: any) {
        // if (!this.isFreePlanUser) { 
            this.showchatGPTDialog = true;
        // }
    }

    public onUseGeneratedProductSuggestions($event: GeneratedProductDescriptionsSuggestions) {
        if ($event.ShortDescription) {
            this.galleryData.ShortDescription = $event.ShortDescription;
        }
        if ($event.MarketingDescription) {
            this.galleryData.LongDescription = $event.MarketingDescription;
        }
        if ($event.SocialMediaPostDescription) {
            this.galleryData.SocialMediaDescription = $event.SocialMediaPostDescription;
        }
        this.closechatGPTDialog({});
    }

    public closechatGPTDialog($event: any) {
        this.showchatGPTDialog = false;
    }
    public onShowMoreProductsClicked($event: any) {
        this.showMoreProductsSidebarVisible = true;
    }

    public onShowMoreProductsClosed($event: any) {
        this.showMoreProductsSidebarVisible = false;
    }

    public preventNegativeValues(event: any, property: 'Length' | 'Width' | 'Height' | 'Weight' | 'CostPrice'): void {
        let value = event.target.value;
        value = value.replace(/-/g, '');
        // Allow only valid decimal numbers (positive values with an optional decimal point)
        const regex = /^[0-9]*\.?[0-9]*$/;
    
        if (!regex.test(value)) {
            // If invalid, revert to previous valid value or set to empty string
            this.galleryData[property] = 0;
        } else {
            // Ensure value remains a valid positive decimal number
            this.galleryData[property] = value;
        }
        if (event.target.value < 0) {
            this.galleryData[property] = 0;
        }
    }

}
